module.exports = __webpack_public_path__ + "static/media/mars-double.023862d1.svg";